import {Handshake} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const missionClaims = {
    id: 'missionClaims',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'missionClaims',
            title: 'Mission Claims',
            type: 'item',
            url: '/missionClaims',
            icon: Handshake,
            breadcrumbs: false,
        },
       
    ]
};

export default missionClaims;
